<script setup lang="ts">
// import { faArrowsMaximize } from '@fortawesome/pro-regular-svg-icons';
import { useData } from '../../_composables/useData';
import ExpandableCard from '@components/util/ExpandableCard.vue';

// const emit = defineEmits<{
//     showMap: [];
// }>();

const { isMobile } = useSize();
const { hotelPackage } = useData();
// const isLoading = computed(() => currentHotelModule.value.isLoadingHotelInfo);
</script>
<template>
    <div>
        <mr-typography size="x-large" weight="700" type="h3" class="title">
            فاصله تا نقاط مهم
        </mr-typography>
        <ExpandableCard
            :default-height="isMobile ? 432 : 272"
            more-title="مکان‌های بیشتر"
            fogies
            :padding-mobile="0"
            :data-value="hotelPackage.popularPlaces.length"
            :disabled="!hotelPackage.popularPlaces.length"
        >
            <div class="attractions-content">
                <div class="attraction-list">
                    <div
                        v-for="(attraction, i) in hotelPackage.popularPlaces"
                        :key="attraction.title || i"
                        class="attraction-item"
                    >
                        <mr-typography
                            color="var(--cool-gray-800)"
                            white-space="nowrap"
                            class="title"
                        >
                            {{ attraction.title }}
                        </mr-typography>
                        <mr-typography
                            weight="500"
                            white-space="nowrap"
                            color="var(--blue-400)"
                        >
                            {{ attraction.distance }} کیلومتر
                        </mr-typography>
                    </div>
                </div>
                <!-- <div
                    class="map-image-wrapper"
                    :class="[
                        { full: !hotelPackage.popularPlaces.length },
                        loadingClass,
                    ]"
                    @click="emit('showMap')"
                >
                    <img
                        v-if="!isLoading && hotelPackage.mapImage"
                        class="map-image"
                        alt="hotel-map"
                        :src="hotelPackage.mapImage"
                    />
                    <mr-button
                        class="fullscreen-button"
                        size="medium"
                        :icon-button="faArrowsMaximize"
                    />
                </div> -->
            </div>
        </ExpandableCard>
    </div>
</template>
<style scoped lang="scss">
.title {
    margin-bottom: 8px;
    margin-top: 0;
    @include mobile-only {
        margin-bottom: 0;
    }
}
.attractions-content {
    display: flex;
    gap: 20px;
    @include mobile-only {
        flex-direction: column-reverse;
        padding: 0;
    }
    .attraction-list {
        display: flex;
        flex-wrap: wrap;
        column-gap: 32px;
        row-gap: 8px;
        flex-grow: 1;
        @include mobile-only {
            padding-inline: 20px;
        }
        .attraction-item {
            flex-basis: calc(50% - 16px);
            max-width: calc(50% - 16px);
            display: flex;
            align-items: center;
            justify-content: space-between;
            @include mobile-only {
                flex-basis: 100%;
                max-width: 100%;
            }
            .title {
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }
    .map-image-wrapper {
        position: relative;
        &.full {
            width: 100%;
            .map-image {
                max-width: unset;
                width: 100%;
            }
        }
        .map-image {
            max-width: 300px;
            object-fit: cover;
            border-radius: 12px;
            cursor: pointer;
            @include mobile-only {
                max-width: unset;
                width: 100%;
                border-radius: 0;
            }
        }
        .fullscreen-button {
            position: absolute;
            top: 8px;
            left: 8px;
        }
    }
}
</style>
